import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSegments = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 5.292 5.292",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "currentColor",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.5,
		strokeWidth: 1.1,
		d: "M1423.57 822.422c-4.67-4.427-20.24 3.229-20.3 12.606-.06 10.376 14.57 15.983 17.01 3.318 1.28-6.645 8.6-10.879 3.29-15.924z",
		clipRule: "evenodd",
		transform: "matrix(.21006 0 0 .17615 -294.455 -144.156)"
	})
});
export default SvgIconSegments;
